define([
    'text!web/common/toast/loading.html',

    'css!web/common/toast/loading.css'
], function(
    tpl
){
    return {
        template: tpl
    }
});


//////////////////
// WEBPACK FOOTER
// ../common/toast/loading.js
// module id = 29
// module chunks = 0 1 2 3 4 5 6